import React, {createContext, useContext, useState, useCallback} from "react";
import {useHistory} from "react-router-dom";
import {isEqual, isFunction} from "lodash";
import {initialFilter} from "./UsersUIHelpers";

const tamalIDStatusOptions = [
  {label: 'הכל', value: 0},
  {label: 'קיים מספר', value: 1},
  {label: 'לא קיים מספר', value: 2},
]

const activeOptions = [
  {label: 'הכל', value: 0},
  {label: 'פעילים', value: 1},
  {label: 'לא פעילים', value: 2},
]

const UsersUIContext = createContext();

export function useUsersUIContext() {
  return useContext(UsersUIContext);
}

export function UsersUIProvider({customersUIEvents, children}) {
  const history = useHistory();
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      for (let key in nextQueryParams) {
        if (nextQueryParams.hasOwnProperty(key) && !nextQueryParams[key]) delete nextQueryParams[key]
      }
      const path = history.location.pathname;
      const newQueryParams = new URLSearchParams(nextQueryParams);
      history.replace(`${path}?${newQueryParams.toString()}`);

      return nextQueryParams;
    });
  }, [history]);

  const initCustomer = {
    id: undefined,
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    gender: "Female",
    status: 0,
    dateOfBbirth: "",
    ipAddress: "",
    type: 1
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    initCustomer,
    newCustomerButtonClick: customersUIEvents.newCustomerButtonClick,
    openEditCustomerDialog: customersUIEvents.openEditCustomerDialog,
    openDeleteCustomerDialog: customersUIEvents.openDeleteCustomerDialog,
    openDeleteUsersDialog: customersUIEvents.openDeleteUsersDialog,
    openFetchUsersDialog: customersUIEvents.openFetchUsersDialog,
    openUpdateUsersStatusDialog: customersUIEvents.openUpdateUsersStatusDialog,
    tamalIDStatusOptions,
    activeOptions
  };

  return <UsersUIContext.Provider value={value}>{children}</UsersUIContext.Provider>;
}
